/* ============================================================================
   VASA storefront behaviour
   Vanilla, no dependencies, no build step.

   ⛔ HISTORY / DO NOT REPEAT: this file used to be the Elariss prototype script
   copied in wholesale. It queried [data-tiers], [data-atc-price] and
   [data-gallery-main] while the Liquid emits #tiers, #atcPrice and #galleryMain,
   so 55 of its 65 hooks matched nothing: the gallery thumbnails were dead and the
   Add-to-cart price never followed the selected tier. It also carried another
   brand's copy and fake identities. Everything below is written against the real
   markup in sections/*.liquid. If you add a hook here, add it to the section in
   the same commit.

   Progressive enhancement throughout: every module no-ops when its markup is
   absent, and nothing here is required for the store to sell. Variant choice is a
   native radio inside {% form 'product' %} and checkout is a native submit, so
   the buy path survives with JS switched off entirely.
   ============================================================================ */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };
  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------------- header
     Mobile drawer. Focus is trapped to the drawer while it is open and returned
     to the trigger on close, because the drawer is the only nav on a phone. */
  (function drawer() {
    var el = $("[data-drawer]");
    if (!el) return;

    var lastTrigger = null;
    var isOpen = function () { return !el.hidden; };

    var open = function (trigger) {
      lastTrigger = trigger || null;
      el.hidden = false;
      document.body.style.overflow = "hidden";
      $$("[data-drawer-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      var first = el.querySelector("a, button");
      if (first) first.focus();
    };

    var close = function () {
      el.hidden = true;
      document.body.style.overflow = "";
      $$("[data-drawer-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      if (lastTrigger) { lastTrigger.focus(); lastTrigger = null; }
    };

    $$("[data-drawer-open]").forEach(function (b) {
      b.addEventListener("click", function () { open(b); });
    });
    $$("[data-drawer-close]").forEach(function (b) {
      b.addEventListener("click", close);
    });
    el.addEventListener("click", function (e) { if (e.target === el) close(); });

    document.addEventListener("keydown", function (e) {
      if (!isOpen()) return;
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var focusables = $$('a[href], button:not([disabled]), input, select, textarea', el)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  })();

  /* Sticky mobile buy bar: hidden while the hero is on screen, shown after it. */
  (function stickyBuy() {
    var bar = $("[data-stickybuy]");
    var hero = $("[data-hero]");
    if (!bar) return;
    if (!hero || !("IntersectionObserver" in window)) { bar.hidden = false; return; }
    new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
    }, { rootMargin: "-40px 0px 0px 0px" }).observe(hero);
  })();

  /* ------------------------------------------------------------ announcement
     Counts down to local midnight and rolls over daily. The unit labels are
     section settings, so they are read from the DOM rather than hardcoded. */
  (function countdown() {
    // There is more than one clock on a PDP: the announcement bar and the free-gift
    // timer in the buy box. Update every instance, not just the first one found.
    var hs = $$("[data-cd-h]"), ms = $$("[data-cd-m]"), ss = $$("[data-cd-s]");
    if (!hs.length) return;
    var pad = function (n) { return String(n).padStart(2, "0"); };
    var put = function (els, v) { els.forEach(function (el) { el.textContent = v; }); };
    var tick = function () {
      var now = new Date();
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var left = Math.max(0, (end - now) / 1000);
      put(hs, pad(Math.floor(left / 3600)));
      put(ms, pad(Math.floor((left % 3600) / 60)));
      put(ss, pad(Math.floor(left % 60)));
    };
    tick();
    setInterval(tick, 1000);
  })();

  /* -------------------------------------------------------------- PDP gallery
     Thumbnails swap the main image. Markup: #galleryMain, #galleryThumbs and
     .gallery__thumb[data-src] in sections/main-product.liquid. */
  (function gallery() {
    var main = $("#galleryMain");
    var thumbs = $$("#galleryThumbs .gallery__thumb");
    if (!main || !thumbs.length) return;

    var select = function (btn) {
      var full = btn.getAttribute("data-src");
      if (!full) return;
      main.src = full;
      var img = btn.querySelector("img");
      if (img) main.alt = img.alt;
      thumbs.forEach(function (t) {
        t.setAttribute("aria-current", String(t === btn));
      });
    };

    thumbs.forEach(function (btn) {
      btn.setAttribute("type", "button");
      btn.addEventListener("click", function () { select(btn); });
    });
  })();

  /* ----------------------------------------------------------- tier selector
     The radios inside {% form 'product' %} are what actually submit, so this
     module only keeps the visible state and the button price in sync with them.
     It never intercepts the submit: a broken script must not break checkout.

     Prices come from Liquid via data-price / data-was on each .tier and are
     already money-formatted upstream, so nothing is formatted here. */
  (function tiers() {
    var group = $("#tiers");
    if (!group) return;

    var atcPrice = $("#atcPrice");
    var tierEls = $$(".tier", group);
    if (!tierEls.length) return;

    var sync = function (tier) {
      tierEls.forEach(function (t) {
        var on = t === tier;
        t.classList.toggle("selected", on);
        t.classList.toggle("is-selected", on);
      });
      var priceEl = $(".tier__price .now", tier);
      if (atcPrice && priceEl) atcPrice.textContent = priceEl.textContent.trim();
    };

    tierEls.forEach(function (tier) {
      var input = tier.querySelector('input[type="radio"]');
      if (!input) return;
      // The label wraps the radio, so a click already toggles it natively.
      // Listening on change keeps keyboard selection working too.
      input.addEventListener("change", function () {
        if (input.checked) sync(tier);
      });
    });

    var checked = tierEls.filter(function (t) {
      var i = t.querySelector('input[type="radio"]');
      return i && i.checked;
    })[0];
    sync(checked || tierEls[0]);
  })();

  /* --------------------------------------------------------------- accordions
     <details> is native. This only enforces one-open-at-a-time per group so a
     long PDP does not turn into a wall of open panels. */
  (function accordions() {
    $$(".accordion-group").forEach(function (group) {
      var items = $$("details.accordion", group);
      items.forEach(function (d) {
        d.addEventListener("toggle", function () {
          if (!d.open) return;
          items.forEach(function (other) { if (other !== d) other.open = false; });
        });
      });
    });
  })();

  /* --------------------------------------------------------- review show-more
     Reveals the cards held back by the section's "cards shown" setting. */
  (function reviewsMore() {
    var btn = $("[data-reviews-more]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      $$(".review-card.is-hidden").forEach(function (c) { c.classList.remove("is-hidden"); });
      btn.style.display = "none";
    });
  })();

  /* ------------------------------------------------------------ scroll reveal
     Satisfies the motion budget. Elements start visible in CSS and are only
     hidden here once we know the observer will run, so a JS failure or a
     reduced-motion preference leaves the page fully readable. */
  (function reveal() {
    if (reduceMotion || !("IntersectionObserver" in window)) return;
    var els = $$(".rsrch__card");
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var delay = els.indexOf(el) % 4 * 90;
        setTimeout(function () {
          el.style.opacity = "1";
          el.style.transform = "none";
        }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: "0px 0px -10% 0px", threshold: 0.15 });

    els.forEach(function (el) {
      el.style.opacity = "0";
      el.style.transform = "translateY(14px)";
      el.style.transition = "opacity var(--e-dur-xl, .6s) var(--e-ease, ease), transform var(--e-dur-xl, .6s) var(--e-ease, ease)";
      io.observe(el);
    });
  })();

  /* The footer year is rendered by Liquid ({{ 'now' | date: '%Y' }}), so there is
     deliberately no JS for it: server-side is correct and needs no hook. */
})();
